var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFundacaoFeed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 156,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 172,
    height: 156
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0h172v156H2V0z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.819 122.818c4.132 0 7.482-3.344 7.482-7.469s-3.35-7.469-7.482-7.469-7.482 3.344-7.482 7.469 3.35 7.469 7.482 7.469zM53.433 122.818c4.132 0 7.482-3.344 7.482-7.469s-3.35-7.469-7.482-7.469-7.481 3.344-7.481 7.469 3.35 7.469 7.481 7.469zM73.048 122.89c4.132 0 7.482-3.344 7.482-7.469s-3.35-7.468-7.482-7.468-7.482 3.343-7.482 7.468 3.35 7.469 7.482 7.469zM92.662 122.89c4.132 0 7.482-3.344 7.482-7.469s-3.35-7.468-7.482-7.468-7.482 3.343-7.482 7.468 3.35 7.469 7.482 7.469z",
    fill: "#727D79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.014 122.847c4.132 0 7.481-3.344 7.481-7.469s-3.35-7.469-7.481-7.469c-4.133 0-7.482 3.344-7.482 7.469s3.35 7.469 7.482 7.469zM51.628 122.847c4.132 0 7.482-3.344 7.482-7.469s-3.35-7.469-7.482-7.469-7.482 3.344-7.482 7.469 3.35 7.469 7.482 7.469zM71.243 122.919c4.132 0 7.482-3.344 7.482-7.469s-3.35-7.469-7.482-7.469-7.482 3.344-7.482 7.469 3.35 7.469 7.482 7.469zM90.857 122.919c4.132 0 7.481-3.344 7.481-7.469s-3.35-7.469-7.481-7.469c-4.132 0-7.482 3.344-7.482 7.469s3.35 7.469 7.482 7.469z",
    fill: "#ACACAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.267 16.742a6.122 6.122 0 00-4.356-2.468 6.134 6.134 0 00-4.744 1.603l-63.985 59a6.258 6.258 0 00-1.998 4.431 6.248 6.248 0 001.782 4.522l7.366 7.47a6.138 6.138 0 004.592 1.869 6.146 6.146 0 004.478-2.13l56.62-66.483a6.223 6.223 0 00.245-7.814z",
    fill: "#079D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.881 97.081a7.53 7.53 0 00-1.989-9.384 7.56 7.56 0 00-3.109-1.473 7.837 7.837 0 00-3.744-7.48 7.867 7.867 0 00-8.374.14 9.96 9.96 0 00-3.003-5.323 9.988 9.988 0 00-11.562-1.429 9.974 9.974 0 00-4.212 4.432 9.736 9.736 0 00-11.728 2.191l10.962 31.331",
    fill: "#EDF1F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.069 57.8l-2.989 1.89 25.504 40.195 2.99-1.89L116.069 57.8z",
    fill: "#079D56"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M116.069 57.8l-2.989 1.89 25.504 40.196 2.99-1.89L116.069 57.8z",
    fill: "url(#paint0_linear)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.677 16.338l49.743 88.197 4.998-4.109-30.332-96.603a5.156 5.156 0 00-3.44-3.398 5.18 5.18 0 00-4.75.932l-16.22 14.98z",
    fill: "#006B3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.402 128.052l-.144-34.129-14.285 10.093s3.827 14.779 14.429 24.036z",
    fill: "#079D56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.402 128.052s32.599 6.834 34.275-33.725a1.444 1.444 0 00-1.372-1.442l-3.958-.1a1.446 1.446 0 00-1.444 1.282l-.116 1.442a1.442 1.442 0 01-1.444 1.284l-2.759.014a1.446 1.446 0 01-1.358-1.442v-1.11a1.444 1.444 0 00-1.314-1.442l-2.889-.173a1.442 1.442 0 00-1.444 1.355v.894a1.44 1.44 0 01-1.445 1.442l-2.108-.1a1.444 1.444 0 01-1.329-1.53v-.749a1.442 1.442 0 00-1.444-1.528h-3.322a1.446 1.446 0 00-1.445 1.197c-.115.807-5.286.447-5.286.447",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M139.402 128.052s32.599 6.834 34.275-33.725a1.44 1.44 0 00-1.373-1.442l-3.957-.1a1.446 1.446 0 00-1.445 1.282l-.115 1.442a1.442 1.442 0 01-1.444 1.284l-2.759.014a1.446 1.446 0 01-1.358-1.442v-1.11a1.44 1.44 0 00-1.314-1.442l-2.889-.173a1.442 1.442 0 00-1.444 1.355v.894a1.44 1.44 0 01-1.445 1.442l-2.108-.1a1.442 1.442 0 01-1.329-1.528v-.75a1.442 1.442 0 00-1.445-1.53h-3.322a1.445 1.445 0 00-1.444 1.198c-.116.807-5.777.346-5.286.447",
    fill: "url(#paint1_linear)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.057 76.463H9.61c-3.884 0-7.034 3.143-7.034 7.021v5.551c0 3.878 3.15 7.022 7.034 7.022h22.446c3.885 0 7.034-3.144 7.034-7.022v-5.55c0-3.879-3.15-7.022-7.034-7.022z",
    fill: "#006B3F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.363 103.007a21.612 21.612 0 013.654-6.95H20.964s4.608 4.701 4.521 7.844",
    fill: "#079D56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M78.363 103.007a21.612 21.612 0 013.654-6.95H20.964s4.608 4.701 4.521 7.844",
    fill: "#079D56"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M78.363 103.007a21.612 21.612 0 013.654-6.95H20.964s4.608 4.701 4.521 7.844",
    fill: "url(#paint2_linear)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.859 128.701H27.493a13.312 13.312 0 01-9.407-3.89 13.267 13.267 0 010-18.78 13.316 13.316 0 019.407-3.889h71.366a13.308 13.308 0 0112.29 8.197 13.272 13.272 0 010 10.164 13.29 13.29 0 01-7.2 7.187 13.326 13.326 0 01-5.09 1.011zM27.493 108.01a7.43 7.43 0 00-5.037 2.28 7.406 7.406 0 000 10.248 7.43 7.43 0 005.037 2.28h71.366a7.43 7.43 0 005.036-2.28 7.407 7.407 0 00-5.036-12.528H27.493z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63,
    d: "M98.859 128.701H27.493a13.312 13.312 0 01-9.407-3.89 13.267 13.267 0 010-18.78 13.316 13.316 0 019.407-3.889h71.366a13.308 13.308 0 0112.29 8.197 13.272 13.272 0 010 10.164 13.29 13.29 0 01-7.2 7.187 13.326 13.326 0 01-5.09 1.011zM27.493 108.01a7.43 7.43 0 00-5.037 2.28 7.406 7.406 0 000 10.248 7.43 7.43 0 005.037 2.28h71.366a7.43 7.43 0 005.036-2.28 7.407 7.407 0 00-5.036-12.528H27.493z",
    fill: "url(#paint3_linear)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.834 96.057v-6.575a8.237 8.237 0 011.652-4.935 8.262 8.262 0 014.284-2.966l3.062-.894a8.263 8.263 0 003.75-2.31 8.242 8.242 0 002.028-3.904l3.61-17.302a8.23 8.23 0 012.884-4.749 8.256 8.256 0 015.248-1.84h26.403a8.259 8.259 0 015.841 2.406 8.234 8.234 0 012.421 5.826v37.243",
    fill: "#00D38D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.755 50.581H47.352a8.256 8.256 0 00-5.205 1.848 8.23 8.23 0 00-2.869 4.713l-3.61 17.302a8.243 8.243 0 01-2.028 3.905 8.264 8.264 0 01-3.75 2.31l-3.062.893a8.261 8.261 0 00-4.284 2.966 8.237 8.237 0 00-1.652 4.936v6.574h61.125V58.814a8.22 8.22 0 00-2.42-5.826 8.248 8.248 0 00-5.842-2.407z",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M73.813 50.581h-26.46a8.256 8.256 0 00-5.206 1.848 8.23 8.23 0 00-2.869 4.713l-3.61 17.302a8.214 8.214 0 01-2.024 3.908 8.236 8.236 0 01-3.754 2.306l-3.076.894a8.262 8.262 0 00-4.276 2.97 8.238 8.238 0 00-1.646 4.932v6.574h61.125V58.814a8.225 8.225 0 00-2.4-5.806 8.254 8.254 0 00-5.804-2.427z",
    fill: "url(#paint4_linear)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.533 54.993a2.284 2.284 0 00-2.239 1.803l-4.333 19.666a2.29 2.29 0 002.239 2.783h12.508V54.993h-8.175z",
    fill: "#EDF1F0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M45.533 54.993a2.284 2.284 0 00-2.239 1.803l-4.333 19.666a2.29 2.29 0 002.239 2.783h12.508V54.993h-8.175z",
    fill: "url(#paint5_linear)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.468 63.904a9.062 9.062 0 00-2.717-6.31 9.093 9.093 0 00-6.369-2.6H56.654v24.251h18.777a2.29 2.29 0 002.253-2.321l-.217-13.02z",
    fill: "#EDF1F0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M77.468 63.904a9.062 9.062 0 00-2.717-6.31 9.093 9.093 0 00-6.369-2.6H56.654v24.251h18.777a2.29 2.29 0 002.253-2.321l-.217-13.02z",
    fill: "url(#paint6_linear)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.128 83.513h-2.961a.52.52 0 00-.52.52v.432c0 .287.233.52.52.52h2.961a.52.52 0 00.52-.52v-.433a.52.52 0 00-.52-.519z",
    fill: "#006B3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.677 16.338l2.888 15.701.073-.057 3.553-4.196",
    fill: "#079D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 127.308,
    y1: 99.898,
    x2: 127.309,
    y2: 57.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4078.5,
    y1: 3014.91,
    x2: 3317.08,
    y2: 2594.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 798.172,
    y1: 638.836,
    x2: 3378.28,
    y2: 638.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7447.26,
    y1: 2224.45,
    x2: 801.878,
    y2: 2224.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 796.573,
    y1: 2355.19,
    x2: 3384.62,
    y2: 2355.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 38.874,
    y1: 67.119,
    x2: 53.708,
    y2: 67.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 844.021,
    y1: 1180.52,
    x2: 1150.85,
    y2: 1180.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFundacaoFeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fundacaoFeed.9805e5b98f00de055ca79b4694128e0e.svg";